import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { DictionaryService } from "src/app/dictionary";
import { DataRowComponent } from "src/app/app/_component/pagination-client-side/data-row.component";

@Component({
  selector: "app-order-view",
  templateUrl: "./order-view.component.html",
  styleUrls: [
    "./order-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class OrderViewComponent implements OnInit, DataRowComponent {
  constructor(public dictionaryServ: DictionaryService) {}

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  statusName(status: number) {
    if (this.dictionaryServ.dictionaryMarketOrderStatus.length > 0) {
      return this.dictionaryServ.dictionaryMarketOrderStatus.find(
        (b) => b.value === status
      ).key;
    }
  }

  ngOnInit() {}
}
